<template>
    <div class="ix-formbuilder-component-summary-content">

        <div class="ix-formbuilder-component-summary-info" v-if="displayMode == 'summary'" >
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Saut de page">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-grip-lines"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label">Saut de page</span>
            </div>
        </div>

        <div class="mt-4" v-if="displayMode == 'readable' || displayMode == 'fillable'">

        </div>

    </div>
</template>

<script>
    export default {
        name: "SeparatorComponent",
        props: ['currentField', 'showIcon', 'displayMode'],
    }
</script>
